module.exports = __webpack_public_path__ + "img/face-grin-beam.a0babe32.svg";